<template>
	<div>
		<div class="certificate">
			<div  class="certificate__wrapper">
				<div class="certificate__header">
					<h5>Exam Instructions</h5>
				</div>
				<div class="certificate__body">
					<p v-html="itemData.exam_instructions"></p>
				</div>
                <div class="btn__group btn__group--form">
                    <div>
                        <label>
                            <input type="checkbox" @click="toggleCheckbox" />
                            <span class="terms">I agree to the Assessment Instructions</span>
                        </label>
                    </div>
                    <button
                        :disabled="!checked"
                        @click.prevent="changeAgreement"
                        class="btn__primary">Confirm</button>
                </div>
			</div>
		</div>
	</div>
</template>

<script>
import eventHub from '../../utils/eventhub';
import { success, fail } from '../../utils/toast';

export default {
	name: 'ExamInstructionModal',
	props: {
		itemData: {
			type: Object,
			default() {
				return {};
			}
		}
    },
    data() {
        return {
            checked: false
        };
    },
    methods: {
        changeAgreement() {
            if (this.checked === true) {
                success({
                    title: 'Success! You can now take the exam!'
                });
                eventHub.$emit('changed-instruction-status', this.checked);
            } else {
                fail({
                    title: 'Hello! You need to agree to the exam instructions to proceed',
                });
            }
        },
        toggleCheckbox() {
            this.checked = !this.checked;
        }
    }
};
</script>

<style lang="scss" scoped>

.wrapper {
	margin: 30px;
}
.certificate {
	display: block;
	font-family: 'Montserrat', sans-serif;
	border: 1px solid $grey-lightest;
	position: relative;
	margin-bottom: 5px;
	border-radius: 4px;
	overflow: hidden;
	background: $white;
	box-shadow: 4px 3px 83px 0px rgba(0,0,0,0.13);
	&__wrapper {
        max-width: 90%;
		margin: auto;
		padding: 20px 30px 30px;
		text-align: center;
	}
	&__header {
		padding-bottom: 20px;
	}
	&__body {
        padding-top: 30px;
        text-align: left;
	}
}
button {
	height: 40px;
}
.credential {
    &__img {
        width: 100%;
        height: auto;
        margin-left: auto;
        margin-right: auto;
    }
}
.btn__group {
    margin: 3em;
    @media #{$mobile} {
        margin: 1em 0;
        text-align: left;
    }
}
.btn__primary {
    margin-top: 2em;
    @media #{$mobile} {
       margin-top: 1em;
    }
    &:disabled {
        cursor: not-allowed;
        background: $grey-light!important;
    }
}
.terms {
    margin: 1em;
    font-size: 1.3em;
    @media #{$mobile} {
        font-size: 1em;
    }
}

</style>
